import { render, staticRenderFns } from "./ColorStep.vue?vue&type=template&id=add05f62&"
import script from "./ColorStep.vue?vue&type=script&lang=js&"
export * from "./ColorStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports